import { render, staticRenderFns } from "./EmployeesQualification.vue?vue&type=template&id=9c78cbf4&scoped=true&"
import script from "./EmployeesQualification.vue?vue&type=script&lang=js&"
export * from "./EmployeesQualification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c78cbf4",
  null
  
)

export default component.exports